// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FtThP","container":"styles_container__3A855"};